module.exports = __webpack_public_path__ + "img/icon_car@2x.21564c9e.png";